"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _Button = _interopRequireDefault(require("../Button"));
var _Picker = require("../Picker");
var _TimeLineItem = _interopRequireDefault(require("./TimeLineItem"));
var _Timeline = _interopRequireDefault(require("@mui/lab/Timeline"));
var _TimelineItem = require("@mui/lab/TimelineItem");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "noOppositeContent", "hideFirstConnector", "hideLastConnector", "dataCy", "align", "children", "withAdd", "addDisabled", "addLabel", "addTooltip", "addOptions", "onAdd", "withRemove", "fullWidth"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: _defineProperty({
      margin: 0,
      padding: 0
    }, "& .".concat(_TimelineItem.timelineItemClasses.root, "::before"), {
      display: function display(_ref) {
        var noOppositeContent = _ref.noOppositeContent;
        return noOppositeContent ? 'block' : 'none';
      }
    })
  };
});
var TimeLine = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var className = _ref2.className,
    noOppositeContent = _ref2.noOppositeContent,
    hideFirstConnector = _ref2.hideFirstConnector,
    hideLastConnector = _ref2.hideLastConnector,
    _ref2$dataCy = _ref2.dataCy,
    dataCy = _ref2$dataCy === void 0 ? 'TimeLine' : _ref2$dataCy,
    _ref2$align = _ref2.align,
    align = _ref2$align === void 0 ? 'left' : _ref2$align,
    children = _ref2.children,
    withAdd = _ref2.withAdd,
    addDisabled = _ref2.addDisabled,
    addLabel = _ref2.addLabel,
    addTooltip = _ref2.addTooltip,
    addOptions = _ref2.addOptions,
    onAdd = _ref2.onAdd,
    withRemove = _ref2.withRemove,
    fullWidth = _ref2.fullWidth,
    props = _objectWithoutProperties(_ref2, _excluded);
  var classes = useStyles({
    noOppositeContent: noOppositeContent
  });
  var validChildren = _react.Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/(0, _react.isValidElement)(child);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Timeline["default"], _objectSpread(_objectSpread({
    className: classes.root,
    align: align
  }, props), {}, {
    ref: ref,
    "data-cy": dataCy,
    children: [validChildren.map(function (child, i) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        isFirst: i === 0,
        isLast: !withAdd && i === (validChildren === null || validChildren === void 0 ? void 0 : validChildren.length) - 1,
        withRemove: withRemove,
        fullWidth: child.props.fullWidth === undefined ? fullWidth : child.props.fullWidth
      });
    }), withAdd && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLineItem["default"], {
      variant: 'outlined',
      color: 'primary',
      isLast: true,
      isFirst: !_react.Children.count(validChildren),
      children: addOptions ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Picker.Picker, {
        widthAuto: true,
        button: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
          add: true,
          variant: 'outlined',
          tooltip: addTooltip,
          tooltipPlacement: 'top',
          children: addLabel
        }),
        options: addOptions,
        disabled: addDisabled,
        onChange: onAdd
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
        add: true,
        onClick: onAdd,
        disabled: addDisabled,
        variant: 'outlined',
        tooltip: addTooltip,
        tooltipPlacement: 'top',
        children: addLabel
      })
    })]
  }));
});
var _default = exports["default"] = TimeLine;